import React from "react";
function Footer() {
  return (
    <div className="footer">
      <p>
        © Copyright {new Date().getFullYear()}. All rights reserved
        www.Idlershome.com.
      </p>
    </div>
  );
}
export default Footer;
